import { useCallback, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { api } from "lib/api";
import { apiURl } from "store/actions";
import { LogoutUser } from "store/reducer";

export function useLogout({ redirectTo = "/sign-in" } = {}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  // Use a ref for the in-flight guard so the callback identity stays stable
  // across renders (avoids invalidating any consumer's useEffect deps).
  const inFlightRef = useRef(false);

  const logout = useCallback(async () => {
    if (inFlightRef.current) return;
    inFlightRef.current = true;
    setIsLoggingOut(true);

    try {
      await api.post(apiURl.logout);
    } catch {
      // Local logout must still complete when the server session is already
      // gone or the logout API returns an error/status false.
    } finally {
      dispatch(LogoutUser());
      inFlightRef.current = false;
      setIsLoggingOut(false);
      navigate(redirectTo, { replace: true });
    }
  }, [dispatch, navigate, redirectTo]);

  return { logout, isLoggingOut };
}

export default useLogout;
